import { ArrayHelper } from '@helpers';
import { GetTestQuestionCollectionQuery } from '@modules/subjects/test-editor/graphql';

import type { DataProxy, FetchResult } from '@apollo/client';
import type {
    GetTestQuestionCollectionQueryType,
    GetTestQuestionCollectionQueryVariables,
    RemoveTestQuestionMutationType,
} from '@modules/types/graphql';

type UpdateRemoveTestQuestionCachePayload = {
    questionId: string;
    subjectId: string;
};

const updateRemoveTestQuestionCache = async (
    proxy: DataProxy,
    mutationResult: FetchResult<RemoveTestQuestionMutationType>,
    payload: UpdateRemoveTestQuestionCachePayload,
): Promise<void> => {
    const removedTestQuestion = mutationResult?.data?.removeOLTestQuestion;

    if (!removedTestQuestion) {
        return;
    }

    const { questionId, subjectId } = payload;

    const proxyQueryOptions = {
        query: GetTestQuestionCollectionQuery,
        variables: { subjectId },
    };

    try {
        const testQuestionCollectionData = proxy.readQuery<
            GetTestQuestionCollectionQueryType,
            GetTestQuestionCollectionQueryVariables
        >(proxyQueryOptions);

        const testQuestionCollection = testQuestionCollectionData?.getOLTestQuestionCollection;

        if (testQuestionCollection) {
            const testQuestions = testQuestionCollection?.items ?? [];

            const items = ArrayHelper.remove(testQuestions, questionId, 'id');

            proxy.writeQuery({
                ...proxyQueryOptions,
                data: {
                    getOLTestQuestionCollection: {
                        ...testQuestionCollection,
                        items,
                    },
                },
            });
        }
    } catch (e) {
        console.log(e);
    }
};

export { updateRemoveTestQuestionCache };
